"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Partner = exports.Job = void 0;
var Job;
(function (Job) {
    Job["ACCOMPAGNEMENT_SCOLAIRE"] = "Accompagnement scolaire";
    Job["ARCHITECTE"] = "Architecte";
    Job["CONSEIL_STRATEGIQUE_ENTREPRISE"] = "Conseil strat\u00E9gique en entreprise";
    Job["CONSULTANT_MARKETING"] = "Consultant marketing";
    Job["DESIGNER"] = "Designer";
    Job["DEVELOPPEUR"] = "D\u00E9veloppeur";
    Job["E_COMMERCANT"] = "E-commer\u00E7ant";
    Job["GRAPHISTE"] = "Graphiste";
    Job["LIVREUR_A_VELO"] = "Livreur \u00E0 v\u00E9lo";
    Job["SERVEUR"] = "Serveur";
    Job["TRADUCTEUR"] = "Traducteur";
})(Job = exports.Job || (exports.Job = {}));
var Partner;
(function (Partner) {
    Partner["AVIZIO"] = "Avizio";
    Partner["BFM"] = "BFM";
    Partner["BRIGAD"] = "Brigad";
    Partner["CARIZY"] = "CARIZY";
    Partner["COMET"] = "Comet";
    Partner["CONVOICAR"] = "Convoicar";
    Partner["COURSIER_JOB"] = "Coursier Job";
    Partner["CREADS"] = "CREADS";
    Partner["CREME_DE_LA_CREME"] = "Cr\u00E8me de la cr\u00E8me";
    Partner["CUBYN"] = "Cubyn";
    Partner["CYCLOFIX"] = "Cyclofix";
    Partner["DELIVEROO"] = "Deliveroo";
    Partner["DREAM_CATCHER"] = "Dream Catcher";
    Partner["EXPLAIN"] = "eXplain";
    Partner["EXTRACADABRA"] = "Extracadabra";
    Partner["FRICHTI"] = "Frichti";
    Partner["FRIZBIZ"] = "Frizbiz";
    Partner["GLOVO"] = "Glovo";
    Partner["HEETCH"] = "Heetch";
    Partner["IBBU"] = "ibb\u00FC";
    Partner["INSPECTVO"] = "InspectVO";
    Partner["IRON_HACK"] = "IronHack";
    Partner["KAPTEN"] = "Kapten";
    Partner["KERMESS"] = "Kermess";
    Partner["LA_TAMBOUILLE"] = "La Tambouille";
    Partner["LE_CLUB_DES_EXTRAS"] = "Le Club des Extras";
    Partner["LE_REACTEUR"] = "Le R\u00E9acteur";
    Partner["LE_PERMIS_LIBRE"] = "Lepermislibre";
    Partner["LES_COURSIERS_FRANCAIS"] = "Les Coursiers Fran\u00E7ais";
    Partner["LES_TONTONS_LIVREURS"] = "Les Tontons Livreurs";
    Partner["LIME"] = "Lime";
    Partner["MALT"] = "Malt";
    Partner["MANNERS"] = "Manners";
    Partner["MERCI_JACK"] = "Merci Jack";
    Partner["MON_SPECIALISTE_AUTO"] = "Mon Specialiste Auto";
    Partner["MY_BIZ_DEV"] = "MyBizDev";
    Partner["NANNY_PLEASE"] = "Nanny Please";
    Partner["NEED_HELP"] = "NeedHelp";
    Partner["NESTOR"] = "Nestor";
    Partner["OCUS"] = "Ocus";
    Partner["ORNIKAR"] = "Ornikar";
    Partner["PARKOPOLY"] = "Parkopoly";
    Partner["PARKOURS"] = "Parkours";
    Partner["SIDE"] = "Side";
    Partner["STOOTIE"] = "Stootie";
    Partner["STUART"] = "Stuart";
    Partner["TASK_RABBIT"] = "TaskRabbit";
    Partner["THE_HAIRCUT"] = "The Haircut";
    Partner["UBER_EATS"] = "Uber Eats";
    Partner["WE_ARE_SMART"] = "WeAreSmart";
})(Partner = exports.Partner || (exports.Partner = {}));
